import ParticipantsNotRegistered from './ParticipantsNotRegistered';

export default ParticipantsNotRegistered;
